export const threeColumns = [
  [
    'Ticket Sales',
    { title: 'Login', link: '/user/login' },
    { title: 'Get Started', link: '/user/signup' }
  ]
];
